export const roles = {
  volunteer: "Vabatahtlik",
  coordinator: "Koordinaator",
  admin: "Administraator",
  super_admin: "Superadministraator",
  som: "Sotsiaalministeerium",
  analytic: "Analüütik",
};
